(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["back-top~index"],{

/***/ 131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
/* harmony import */ var _utils_props_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);
/* harmony import */ var _base_vc_util_Dom_addEventListener__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



 // 样式文件
// import './style/index.scss';

function getDefaultTarget() {
  return window;
}

var BackTopProps = {
  visibilityHeight: utils__WEBPACK_IMPORTED_MODULE_0__[/* vueTypes */ "d"].number,
  target: utils__WEBPACK_IMPORTED_MODULE_0__[/* vueTypes */ "d"].func
};
var BackTop = {
  name: 'MegBackTop',
  props: _objectSpread(_objectSpread({}, BackTopProps), {}, {
    visibilityHeight: utils__WEBPACK_IMPORTED_MODULE_0__[/* vueTypes */ "d"].number.def(400)
  }),
  data: function data() {
    this.scrollEvent = null;
    return {
      visible: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      var getTarget = _this.target || getDefaultTarget;
      _this.scrollEvent = Object(_base_vc_util_Dom_addEventListener__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(getTarget(), 'scroll', _this.handleScroll);

      _this.handleScroll();
    });
  },
  beforeCreate: function beforeCreate() {},
  methods: {
    getCurrentScrollTop: function getCurrentScrollTop() {
      var getTarget = this.target || getDefaultTarget;
      var targetNode = getTarget();

      if (targetNode === window) {
        return window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop;
      }

      return targetNode.scrollTop;
    },
    scrollToTop: function scrollToTop(e) {
      var _this$target = this.target,
          target = _this$target === void 0 ? getDefaultTarget : _this$target;
      scrollTo(0, {
        getContainer: target
      });
      this.$emit('click', e);
    },
    handleScroll: function handleScroll() {
      var visibilityHeight = this.visibilityHeight,
          _this$target2 = this.target,
          target = _this$target2 === void 0 ? getDefaultTarget : _this$target2;
      var scrollTop = Object(utils__WEBPACK_IMPORTED_MODULE_0__[/* getScroll */ "a"])(target(), true);
      this.visible = scrollTop > visibilityHeight;
    }
  },
  render: function render() {
    var h = arguments[0];
    var $slots = this.$slots;
    var prefixCls = 'meg-back-top';
    var defaultElement = h("div", {
      "class": "".concat(prefixCls, "-content")
    }, [h("div", {
      "class": "".concat(prefixCls, "-icon")
    })]);
    var divProps = {
      on: _objectSpread(_objectSpread({}, Object(_utils_props_util__WEBPACK_IMPORTED_MODULE_1__["getListeners"])(this)), {}, {
        click: this.scrollToTop
      }),
      class: prefixCls
    };
    var backTopBtn = this.visible ? h("div", divProps, [$slots.default || defaultElement]) : null;
    return backTopBtn;
  }
};

BackTop.install = function (Vue) {
  Vue.component(BackTop.name, BackTop);
};

/* harmony default export */ __webpack_exports__["default"] = (BackTop);

/***/ })

}]);